var _mask, _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6_657",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 44.5C0.5 20.1995 20.1995 0.5 44.5 0.5C68.8005 0.5 88.5 20.1995 88.5 44.5C88.5 68.8005 68.8005 88.5 44.5 88.5C20.1995 88.5 0.5 68.8005 0.5 44.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 84.5C22.4086 84.5 4.5 66.5914 4.5 44.5H-3.5C-3.5 71.0097 17.9903 92.5 44.5 92.5V84.5ZM84.5 44.5C84.5 66.5914 66.5914 84.5 44.5 84.5V92.5C71.0097 92.5 92.5 71.0097 92.5 44.5H84.5ZM44.5 4.5C66.5914 4.5 84.5 22.4086 84.5 44.5H92.5C92.5 17.9903 71.0097 -3.5 44.5 -3.5V4.5ZM44.5 -3.5C17.9903 -3.5 -3.5 17.9903 -3.5 44.5H4.5C4.5 22.4086 22.4086 4.5 44.5 4.5V-3.5Z",
    fill: "#C9DAE1",
    mask: "url(#path-1-inside-1_6_657)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 38.5,
    width: 5,
    height: 29,
    rx: 2,
    fill: "#C9DAE1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 23.5,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "#C9DAE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder);
export default __webpack_public_path__ + "static/media/Border.a6317725ea028f92c18dfbf4ec239c4b.svg";
export { ForwardRef as ReactComponent };